<template>
  <div>
    <project-one-bike-image qaid="lead-gen-preview-bike-image" class="project-one-bike-image" />

    <div class="flex justify-center mt-2">
      <trek-button qaid="lead-gen-preview-edit-config-button" text icon="arrow_back" @click="handleEditConfigClick">
        <span v-html="bp('orderEditConfig')" />
      </trek-button>
    </div>
  </div>
</template>

<script>
import ProjectOneBikeImage from '@/projectOne/components/shared/ProjectOneBikeImage';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'ProjectOneLeadGenPreview',

  components: {ProjectOneBikeImage, TrekButton},

  methods: {
    handleEditConfigClick() {
      this.$router.push('summary');
    },
  },
};
</script>
